import { readBrowserStorageItem, writeBrowserStorageItem } from './browserStorage';

const DEVICE_ID_STORAGE_KEY = 'loan_device_id';
let memoryDeviceId = '';

const createRandomPart = () =>
  Math.random().toString(36).replace(/[^a-z0-9]+/g, '').slice(0, 10);

const generateDeviceId = () => {
  const cryptoUuid =
    typeof window !== 'undefined' && window.crypto?.randomUUID
      ? window.crypto.randomUUID().replace(/-/g, '')
      : `${Date.now().toString(36)}${createRandomPart()}${createRandomPart()}`;
  return `web_${cryptoUuid}`.slice(0, 64);
};

export const getOrCreateDeviceId = () => {
  const current = String(readBrowserStorageItem(DEVICE_ID_STORAGE_KEY) || memoryDeviceId).trim();
  if (current) {
    memoryDeviceId = current;
    return current;
  }

  const next = generateDeviceId();
  memoryDeviceId = next;
  writeBrowserStorageItem(DEVICE_ID_STORAGE_KEY, next);
  return next;
};
